import { Box, Link, Paper, Table, TableBody, TableContainer, Typography } from "@mui/material";
import { linkStyling } from "../styles/styling";

// COMPONENTS
import SpeedLimit from "./SpeedLimit";

// SPEED LIMITS
export default function SpeedLimits() {
    return (
        <Box component="section" id="speedlimits" display="flex" flexDirection="column" sx={{ mt: 2 }}>
            <Box>
                <Typography variant="h5" fontFamily="Public Sans" color="white" sx={{ mb: 2 }}>
                    <Link href="#speedlimits" sx={linkStyling}>#</Link> Speed Limits
                </Typography>
            </Box>

            <Box>
                <TableContainer component={Paper}>
                    <Table aria-label="speed limits table">
                        <TableBody>
                            <SpeedLimit roadType="City Roads" maxSpeedInMPH={40} />
                            <SpeedLimit roadType="County Roads" maxSpeedInMPH={50} />
                            <SpeedLimit roadType="Great Ocean Highway" maxSpeedInMPH={70} />
                            <SpeedLimit roadType="Freeways" maxSpeedInMPH={75} />
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    )
}
